export const tr = {
    'block-errors': {
        one: 'Blokta {count} hata var',
        some: 'Blokta {count} hata var',
        many: 'Blokta {count} hata var',
        none: 'Blokta {count} hata var'
    },
    'one-block-error': 'Blokta hata var'
};
